import { configureStore } from '@reduxjs/toolkit';
import { atvApi } from 'src/api/atv/atvApi';
import { internalApi } from 'src/api/internal/internalApi';
import rootReducer from './rootReducer';

export type RootState = ReturnType<typeof rootReducer>;

const applyMiddleware = (getDefaultMiddleware: any, enableAddOns: boolean) => {
  const middlewares = getDefaultMiddleware();
  const sharedMiddlewares = [atvApi.middleware, internalApi.middleware];
  const addOns: never[] = [];

  return enableAddOns
    ? middlewares.concat(sharedMiddlewares).concat(addOns)
    : middlewares.concat(sharedMiddlewares);
};

export const setupStore = (preloadedState?: Partial<RootState>, enableAddOns = true) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      applyMiddleware(getDefaultMiddleware, enableAddOns),
    preloadedState,
  });

export type AppStore = ReturnType<typeof setupStore>;

export type AppDispatch = AppStore['dispatch'];

export default setupStore();
